import { LabelHTMLAttributes, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type FieldLabelProps = Omit<
  LabelHTMLAttributes<HTMLLabelElement>,
  "children"
> & {
  children?: ReactNode;
  value?: ReactNode;
  required?: boolean;
};

export const FieldLabel = ({
  children,
  value,
  required,
  className,
  ...rest
}: FieldLabelProps) => (
  <label
    className={twMerge(
      "mb-1 block text-sm font-medium text-gray-700",
      className
    )}
    {...rest}
  >
    {children ?? value}
    {required && (
      <span className="ml-0.5 text-gray-400" aria-hidden="true">
        *
      </span>
    )}
  </label>
);

export default FieldLabel;
